module.exports = __webpack_public_path__ + "56be3b5dc3cc5d20d98ab6f8e7e0e1f0.svg";